import {Grid} from '@logistics-frontend/blocks'
import {LightningIcon} from '@logistics-frontend/blocks/icons'
import {useMediaQuery} from '@logistics-frontend/blocks/legacy'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {TogglePlate} from '@logistics-frontend/blocks/lpc/toggle-button'
import {useI18n} from '@logistics-frontend/core/i18n'
import {ToggleButtonProps} from '@material-ui/lab'
import {MaxTariff} from '@yandex-taxi/js-integration-api'
import clsx from 'clsx'
import React, {useEffect, useRef} from 'react'

import {useEstimateFareDisclaimer, useEstimateTitle} from '../../../shared/buttons/hooks'
import {Tariff} from '../../consts'
import {useClasses, useTogglePlateClasses} from './classes'

const scrollOptions: ScrollIntoViewOptions = {
  behavior: 'smooth',
  inline: 'center',
  block: 'nearest',
}

type Props = ToggleButtonProps & {
  currentValue: string
  tariff: MaxTariff
}

const TariffPlate: React.FC<Props> = ({currentValue, tariff, ...otherProps}) => {
  const t = useI18n()
  const ref = useRef<HTMLButtonElement>(null)
  const classes = useClasses()
  const togglePlateClasses = useTogglePlateClasses()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const price = useEstimateTitle('', tariff.class, false)
  const isPopular = useEstimateFareDisclaimer(tariff.class)

  const TARIFFS_SUBTITLES: Record<Tariff, React.ReactNode> = {
    [Tariff.COURIER]: t('order.tariffs.courier_subtitle', 'Доставка до двери \nПосылка до 10 кг'),
    [Tariff.EXPRESS]: t('order.tariffs.express_subtitle', 'Посылка до 20 кг'),
    [Tariff.CARGO]: t('order.tariffs.cargo_subtitle', 'Перевозка крупных вещей'),
  }

  useEffect(() => {
    if (tariff.class === currentValue && matches) {
      ref.current.scrollIntoView(scrollOptions)
    }
  }, [tariff, currentValue, matches])

  return (
    <TogglePlate ref={ref} classes={togglePlateClasses} {...otherProps}>
      <Grid direction="column" spacing={1} container>
        <Grid item>
          <div
            className={clsx(classes.icon, {
              [classes.iconCourier]: tariff.class === Tariff.COURIER,
              [classes.iconExpress]: tariff.class === Tariff.EXPRESS,
              [classes.iconCargo]: tariff.class === Tariff.CARGO,
            })}
          />
        </Grid>
        <Grid className={classes.title} item>
          {tariff.name}
        </Grid>
        {TARIFFS_SUBTITLES[tariff.class] && (
          <Grid className={classes.subtitle} item>
            {TARIFFS_SUBTITLES[tariff.class]}
          </Grid>
        )}
        <Grid alignItems="center" className={classes.price} container item>
          {price ? (
            <>
              {isPopular ? <LightningIcon /> : undefined}
              {price}
            </>
          ) : (
            <>&mdash;</>
          )}
        </Grid>
      </Grid>
    </TogglePlate>
  )
}

export default TariffPlate
